<!--
	TEMPLATE
-->
<template>

	<div class="portals-box editable-item mdc-layout-grid__inner">
		<!-- Title -->
	   <div class="portals-box__title mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-phone editable-item__title">
			<div class="editable-item__centered"><span @click.prevent="$router.push('/settings/portals')">Uploads</span></div>
		</div>
		<!-- Content -->
		<div class="portals-box__list mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-6-phone editable-item__middle-cell">
			<div v-if="updatingPortals">
				<span class="portals-box__no-portals">Updating portals...</span>
			</div>
			<div v-if="!updatingPortals">
				<!-- Zoopla -->
				<a v-if="isZooplaActive" :href="zooplaPortal.liveUrl" class="portals-box__portal" target="_blank" :onclick="zooplaPortal.liveUrl == '' ? 'return false' : ''">
					<img class="portals-box__portal-icon" src="/static/img/zoopla-icon.png">
					<span class="mq-md-hidden portals-box__date">{{ dateFormatted(zooplaPortal.updated_at) }}</span>
					<span v-if="zooplaPortal.live && !zooplaPortal.errors" class="portals-box__status portals-box__status--success"></span>
					<span v-if="zooplaPortal.errors" class="portals-box__status portals-box__status--failure" v-tooltip="'Please ensure you have uploaded at least one photograph, the EPC graph, and property descriptions.'"></span>
				</a>
				<!-- Rightmove -->
				<a v-if="isRmActive" :href="rmPortal.liveUrl" class="portals-box__portal" target="_blank" :onclick="rmPortal.liveUrl == '' ? 'return false' : ''">
					<img class="portals-box__portal-icon" src="/static/img/rightmove-icon.png">
					<span class="mq-md-hidden portals-box__date">{{ dateFormatted(rmPortal.updated_at) }}</span>
					<span v-if="rmPortal.live && !rmPortal.errors" class="portals-box__status portals-box__status--success"></span>
					<span v-if="rmPortal.errors" class="portals-box__status portals-box__status--failure" v-tooltip="'Please ensure you have uploaded at least one photograph, the EPC graph, and property descriptions.'"></span>
				</a>
        <!-- OnTheMarket -->
				<a v-if="isOtmActive" :href="otmPortal.liveUrl" class="portals-box__portal" target="_blank" :onclick="otmPortal.liveUrl == '' ? 'return false' : ''">
					<img class="portals-box__portal-icon" src="/static/img/onthemarket-icon.png">
					<span class="mq-md-hidden portals-box__date">{{ dateFormatted(otmPortal.updated_at) }}</span>
					<span v-if="otmPortal.live && !otmPortal.errors" class="portals-box__status portals-box__status--success"></span>
					<span v-if="otmPortal.errors" class="portals-box__status portals-box__status--failure" v-tooltip="'Please ensure you have uploaded at least one photograph, the EPC graph, and property descriptions.'"></span>
				</a>
				<div v-if="!isRmActive && !isZooplaActive && !isOtmActive" class="">
					<span class="portals-box__no-portals">Not sent to portals</span>
				</div>
			</div>
		</div>
		<!-- Divider -->
		<div class="mq-md-show mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
			<hr>
		</div>
	</div>
</template>

<!--
	SCRIPT
-->
<script>
import utils from '@/libs/mixins.js';
import vModelNested from '@/libs/vModelNested.js';

export default {
	props: ['value', 'updatingPortals'],
	mixins: [utils],
	data: function() {
		return {
		}
	},
	computed: {
		propertyPortals: vModelNested,
    rmPortal: function() {
			const portal = this.propertyPortals.filter(portal => (portal.portalId === "rm"));
			return portal.length > 0 ? portal[0] : {};
		},
    otmPortal: function() {
			const portal = this.propertyPortals.filter(portal => (portal.portalId === "otm"));
			return portal.length > 0 ? portal[0] : {};
		},
		zooplaPortal: function() {
			const portal = this.propertyPortals.filter(portal => (portal.portalId === "zoopla"));
			return portal.length > 0 ? portal[0] : {};
		},
		isRmActive: function() {
      const isPortalActive = this.$parent.portals.filter(p => { return p.portalId == 'rm' && p.active === true });
			return this.rmPortal.hasOwnProperty('portalId') && isPortalActive.length ? true : false;
		},
		isOtmActive: function() {
      const isPortalActive = this.$parent.portals.filter(p => { return p.portalId == 'otm' && p.active === true });
			return this.otmPortal.hasOwnProperty('portalId') && isPortalActive.length ? true : false;
		},
		isZooplaActive: function() {
      const isPortalActive = this.$parent.portals.filter(p => { return p.portalId == 'zoopla' && p.active === true });
			return this.zooplaPortal.hasOwnProperty('portalId') && isPortalActive.length ? true : false;
		}
	},
	methods: {
		dateFormatted: function(timestamp) {
			const date = new Date(timestamp);
			const day = date.getDate();
			const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
			const year = date.getFullYear();
			const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
			const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
			return `${day}/${month}/${year} ${hours}:${minutes}`;
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/PortalsStatusBox.vue